// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AccountThumbnailsDataModel, getAccountThumbnailsData } from "@ces/App/Services/AccountThumbnailsService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";

type HandlerType = ApiHandler<{}, AccountThumbnailsDataModel>;

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getAccountThumbnailsData();
    } catch (error) {
        logger.error(error);
    }
};

export const DispatchCompleteLoadAccountThumbnailsData: HandlerType = props => {
    props.dispatch({
        type: "xAccountThumbnails/CompleteLoadAccountThumbnailsData",
        accountThumbnailsData: props.apiResult,
    } as any);
};

export const chain = [RequestDataFromApi, DispatchCompleteLoadAccountThumbnailsData];

const loadAccountThumbnailsData = createHandlerChainRunner(chain, "loadAccountThumbnailsData");

export default loadAccountThumbnailsData;
